/** "/" sends the user to their preferred start page (Instellingen → Startpagina). */
import { Navigate } from 'react-router';
import type { MeSettings } from '../../shared/api.js';
import { useMe } from '../lib/session.js';

const HOME_PATH: Record<NonNullable<MeSettings['home']>, string> = {
  mijn: '/mijn',
  projecten: '/projecten',
  gantt: '/gantt',
  team: '/team',
};

export function homePath(home: MeSettings['home']): string {
  return home ? HOME_PATH[home] : '/mijn';
}

export function HomeRedirect() {
  const me = useMe();
  return <Navigate to={homePath(me?.settings.home)} replace />;
}
